import React, { FunctionComponent } from 'react'
import Svg, { G, Mask, Path } from 'react-native-svg'

export const ChildTherapySecondaryRec: FunctionComponent<ChildTherapySecondaryRecProps> = ({
  width = 80,
  height = 80,
}) => {
  return (
    <Svg width={width} height={height} viewBox='0 0 60 59' fill='none'>
      <Mask
        id='a'
        style={{
          maskType: 'alpha',
        }}
        maskUnits='userSpaceOnUse'
        x={0}
        y={0}
        width={60}
        height={59}
      >
        <Path
          d='M59.235 29.316c-.078-2.214-.417-4.508-.951-6.789-.873-3.674-2.307-7.296-4.273-10.397a28.514 28.514 0 00-1.433-2.032C48.89 5.342 43.3 2.697 37.58 1.458 31.209.078 24.434.481 18.309 2.748 9.45 6.032 3.416 13.224 1.448 22.475.692 25.98.47 29.941.809 33.746H.783c.196 2.163.587 4.274 1.172 6.215 2.177 7.193 7.466 12.9 14.203 16.093 3.648 1.732 7.726 2.592 11.87 2.788 4.235.196 8.535-.339 12.51-1.433.26-.064.508-.13.769-.208 3.113-.912 5.823-2.32 8.143-4.183 2.528-2.02 4.612-4.56 6.229-7.674.351-.678.664-1.355.963-2.046 1.902-4.418 2.75-9.212 2.58-13.968l.013-.012v-.002z'
          fill='#FFE9E3'
        />
      </Mask>
      <G mask='url(#a)'>
        <Path
          d='M30.437 62.538c17.42 0 31.543-14.122 31.543-31.543C61.98 13.573 47.858-.55 30.437-.55S-1.107 13.573-1.107 30.995c0 17.42 14.123 31.543 31.544 31.543z'
          fill='#FFE9E3'
          stroke='#3BA5B5'
          strokeMiterlimit={10}
        />
        <Path
          d='M15.983 25.805s-3.865-1.18-5.492 1.667c-1.628 2.848-1.506 10.009 1.465 10.741 2.97.733 3.092 0 3.092 0l.936-12.408h-.001z'
          fill='#E77B56'
        />
        <Path
          d='M20.818 52.878c-.426.922-4.039.85-5.243 0-.37-.262-.513-1.335-.532-2.69-.042-3.04.533-7.51.533-7.51l4.108-.568-.74 8.076-.038.424s2.337 1.346 1.912 2.267v.001z'
          fill='#F59013'
        />
        <Path
          d='M20.818 52.878c-.426.922-4.039.85-5.243 0-.37-.262-.513-1.335-.532-2.69h3.901l-.039.423s2.338 1.346 1.913 2.267z'
          fill='#E4744C'
        />
        <Path
          d='M26.928 52.878c-.426.922-4.039.85-5.243 0-.37-.262-.513-1.335-.532-2.69-.043-3.04.532-7.51.532-7.51l4.11-.568-.74 8.076-.04.424s2.338 1.346 1.913 2.267v.001z'
          fill='#F59013'
        />
        <Path
          d='M26.928 52.878c-.426.922-4.039.85-5.243 0-.37-.262-.513-1.335-.532-2.69h3.901l-.039.423s2.338 1.346 1.913 2.267z'
          fill='#E4744C'
        />
        <Path
          d='M21.15 16.895s-1.87-2.36-4.882-.814c-3.011 1.546-3.988 4.639-2.116 7.486 1.871 2.848 4.639 1.303 4.639 1.303l2.36-7.974v-.001z'
          fill='#544022'
        />
        <Path
          d='M14.925 26.415s.082-1.262 2.87-1.668c2.787-.406 4.74 1.058 5.96 4.72 1.22 3.661 3.498 11.758 2.074 13.264-1.424 1.505-10.456 2.604-11.147.244-.691-2.36-.814-13.508.243-16.56z'
          fill='#FFC522'
        />
        <Path
          d='M13.95 28.45s1.704-1.058 3.05.488c1.344 1.547 1.877 6.258 0 7.283-1.878 1.025-3.8.529-3.8.529l.18 1.465s2.097.488 3.794-.49c1.698-.975 3.336-2.318 3.025-5.37-.311-3.05-2.194-6.915-6.054-6.224-3.858.691-.197 2.319-.197 2.319h.001z'
          fill='#E77B56'
        />
        <Path
          d='M16.108 30.462s1.419 1.18 4.102-.285c2.684-1.465 2.893-1.057 3.207-.489.313.57 1.288 3.214 0 4.11-1.29.894-7.493 2.725-8.33 2.197-.835-.53 1.02-5.33 1.02-5.33'
          fill='#FFC522'
        />
        <Path
          d='M20.296 17.445c.25.007 1.342-.062 1.952 1.465.61 1.526 1.465 3.05 1.037 4.516-.427 1.465-3.356 3.235-5.492.366-2.136-2.869.489-6.407 2.503-6.347z'
          fill='#A2633E'
        />
        <Path
          d='M17.407 22.478s1.098-2.41 2.4-2.98c1.3-.57 2.726-.162 2.766-.488.04-.327-.529-3.093-3.336-1.994-2.808 1.099-3.822 4.292-2.913 5.655.798 1.196 1.848.434 1.081-.194l.002.001z'
          fill='#E27A53'
        />
        <Path d='M17.923 21.655s-1.105-1.1-1.533 0c-.427 1.098 1.404 2.136 1.404 2.136l.129-2.136z' fill='#966A40' />
        <Path d='M36.18 13.188s-6.017-5.295-4.445-6.016c1.573-.72 7.993 5.765 7.993 5.765l-3.549.251z' fill='#A99881' />
        <Path
          d='M44.03 51.12c-.03 1.022-.083 1.713-.166 1.878-.457.915-4.274 1.07-5.799-.153-1.348-1.08 1.154-1.743 1.747-1.882l.122-.026s-.879-8.242-1.042-9.221c-.164-.979-.828-.319-.828-.319s-1.112 6.419-1.875 9.804c-.255 1.135-.47 1.93-.59 2.025-.479.381-4.482 1.222-5.932-.305-1.323-1.391 1.93-1.768 2.74-2.693a.728.728 0 00.16-.282c.306-1.145 1.21-15.111 1.21-15.111h10.086s.307 11.608.166 16.285h.001z'
          fill='#CEB9A7'
        />
        <Path
          d='M33.373 35.997v-7.534s-3.333-.722-1.908-3.472c.542-1.044 2.833-4.128 5.575-4.979 2.743-.851 8.294.619 9.638 5.418 1.09 3.886-2.41 5.196-2.41 5.196v5.7s-6.049 2.359-10.898-.328h.003z'
          fill='#85CCD5'
        />
        <Path d='M36.052 10.91s-2.513-.088-1.47 3.482c1.043 3.57 1.47-3.482 1.47-3.482z' fill='#523F20' />
        <Path
          d='M35.404 11.89s-2.751 6 .786 6.8c3.538.8 4.98-.904 5.438-2.083.459-1.179-1.31-9.04-6.224-4.716v-.001z'
          fill='#E1A97F'
        />
        <Path
          d='M36.518 17.916s-.655 3.145.59 3.472c1.245.328 2.49-.523 2.62-.982.131-.459 0-3.076 0-3.076l-3.21.586zM33.4 26.847s-.7-1.745-1.75-1.655c-1.05.09-1.546 4.935-.832 6.133.714 1.197 3.297 2.446 5.527 1.643 2.23-.802-.968-2.512-1.96-2.808-1.495-.447-.986-3.312-.986-3.312h.001zM44.27 28.08c-.013-.105-.587-1.338.86-2.157.797-.45 1.427-.675 1.605-.315.18.36 1.427 6.825-.668 7.315-2.095.49-5.16 1.025-6.282-.623-1.12-1.65 2.18-2.007 2.402-2.007.222 0 2.395.123 2.082-2.212l.001-.001z'
          fill='#E1A97F'
        />
        <Path
          d='M34.83 11.477s.763-1.524 3.235-1.186c2.473.339 5.193 5.2 5.193 5.2s.757 2.259-.891 2.779c-1.65.518-3.11 1.126-3.235-1.8-.103-2.415-4.747-3.61-4.3-4.993h-.002z'
          fill='#523F20'
        />
        <Path
          d='M35.597 10.29s3.55-2.855 6.1-1.218c2.55 1.638 3.206 5.109 1.96 6.419 0 0-.524.614-1.31 0-.784-.614-2.627-4.636-6.75-5.2z'
          fill='#A99881'
        />
        <Path
          d='M44.03 51.12c-.03 1.022-.083 1.713-.166 1.878-.457.915-4.273 1.07-5.798-.153-1.35-1.08 1.153-1.743 1.746-1.882h.001c.83.314 2.219.667 4.218.155v.002zM36.19 51.202c-.255 1.135-.47 1.93-.59 2.025-.478.381-4.482 1.223-5.932-.305-1.323-1.391 1.93-1.767 2.74-2.692.594.576 1.752 1.26 3.782.972z'
          fill='#957C64'
        />
      </G>
    </Svg>
  )
}

type ChildTherapySecondaryRecProps = {
  width?: number
  height?: number
}
